export default "__VITE_ASSET__CewAwRuh__"